module.exports = __webpack_public_path__ + "img/pr-3.351c1926.png";